import put from './put';

export default { put };
